import api from "./api";

export const getParticipante = async (idParticipante) => {
    const response = await api.get(
        `/Participante/GetParticipanteViewById?idParticipante=${idParticipante}`
    );

    return response.data.data;
}
export const getsParticipanteAlergia = async (idParticipante) => {
    const response = await api.get(
        `/Participante/GetsParticipanteAlergiaViewById?idParticipante=${idParticipante}`
    );

    return response.data.data;
}
export const getsParticipantePersonaAutorizada = async (idParticipante) => {
    const response = await api.get(
        `/Participante/GetsParticipantePersonaAutorizadaViewById?idParticipante=${idParticipante}`
    );

    return response.data.data;
}
export const getsParticipanteNivelLenguaje = async (idParticipante) => {
    const response = await api.get(
        `/Participante/GetsParticipanteNivelLenguajeViewById?idParticipante=${idParticipante}`
    );

    return response.data.data;
}
export const deleteParticipanteAlergia = (idParticipante, numero) =>
    api.delete(
        "/Participante/DeleteParticipanteAlergia",{params: {idParticipante, numero}}
    );
export const deleteParticipantePersonaAutorizada = (idParticipante, numero) =>
    api.delete(
        "/Participante/DeleteParticipantePersonaAutorizada",{params: {idParticipante, numero}}
    );
export const deleteParticipanteNivelLenguaje = (idParticipante, numero) =>
    api.delete(
        "/Participante/DeleteParticipanteNivelLenguaje",{params: {idParticipante, numero}}
    );
export const postParticipanteWithDetails = (dataPost) =>
    api.post(
        "/Participante/AddUpdateParticipanteWithDetails",dataPost
    )

export const getsParticipantesResumenView = async () => {
    const response = await api.get('/Participante/GetsParticipantesResumenView');

    return response.data.data;
}

export const getsParticipantesResumenViewByMemberOrRelative = async (member, relative) => {
    const response = await api.get('/Participante/GetsParticipantesResumenViewByMemberOrRelative?'
            + 'member=' + (member == null ? "" : member)
            + '&relative=' + (relative == null ? "" : relative));

    return response.data.data;
}
